import React, { Fragment, useEffect, useReducer, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { KTSVG } from '../../../_metronic/helpers'
import { expensetypeInitialsForApp, expensetypeInitialsForUpdate } from './interfaces/expensetypeClass';
import Select, { StylesConfig } from 'react-select';
import { getAccountTaxCodeByAccountTaxZoneIdAsync } from '../taxcode/taxcodeSlice';
import Dropdown from 'react-bootstrap/Dropdown';
import { addAccountExpenseTypeAsync, updateAccountExpenseTypeAsync, getAccountExpenseTypeByAccountTaxZoneIdAsync } from './expensetypeSlice'
import fetchAPI from "../../../common/fetchAPI";
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';


const ExpenseTypeForm = (props: any) => {
    const { modelRef, AccountTaxZoneId, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [disabledCount, setDisabledCount] = useState(0)
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expensetypeInitialsForApp);
    const { selectedRecord, expensetypeList, isLoading } = useAppSelector((state) => state.expensetype);
    const dispatch = useAppDispatch();
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const [taxCodeArray, setTaxCodeArray] = useState<any | ''>([]);

    const getTaxCode = async () => {
        const response = await fetchAPI('api/taxcodes/GetAccountTaxCodeByAccountTaxZoneId/' + AccountTaxZoneId, 'Get', '', true, '7b6f1610-fd9a-41d2-aa9f-f95225f6a59c');
        const json = await response.json();

        json.map((item: any) => {
            item.value = item.AccountTaxCodeId;
            item.label = item.TaxCode;
            delete item.TaxCode;
            delete item.AccountTaxCodeId;
            delete item.Formula;
            delete item.IsDisabled;
        });
        const finalData = [{ label: 'Select', value: 0 }, ...json];
        setTaxCodeArray(finalData);
    }

    useEffect(() => {
        getTaxCode();
    }, [AccountTaxZoneId]);


    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(expensetypeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            if (stateItem.AccountTaxCodeId === null) {
                setSelectedOption({ value: 0, label: 'Select' });
            } else {
                setSelectedOption({ value: stateItem.AccountTaxCodeId, label: stateItem.TaxCode });
            }
            stateItem.IsQuantityField = stateItem.IsQuantityField === 'Yes' ? true : false;
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
          
            setCurrentFieldsData(expensetypeInitialsForApp);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

        calculatedDisabledValue();
    }, [selectedRecord])





    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountExpenseTypeAsync({ ...values, AccountTaxZoneId: AccountTaxZoneId }))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Expense type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addAccountExpenseTypeAsync({ ...values, AccountTaxZoneId: AccountTaxZoneId }))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Expense type Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }

    const handleOptionChange = (data: any) => {
        setCurrentFieldsData({ ...currentFieldsData, AccountTaxCodeId: data.target.value, AccountTaxZoneId: AccountTaxZoneId });
    }
    const calculatedDisabledValue = () => {
        if (expensetypeList.length > 0) {
            let index = 0;
            expensetypeList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(expensetypeList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    ExpenseType: yup
                        .string()
                        .label('ExpenseType')
                        .trim()
                        .required
                        // (t('Expense type is required'))
                        (getValueFromResource('Delete',dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                                                        // t('Update') 
                                                        getValueFromResource('Update ',dispatch, t):
                                                        //  t('Add')}
                                                        getValueFromResource('Add ',dispatch, t)}
                                                          {/* {t('Expense Type')} */}
                                                          {getValueFromResource('Expense Type',dispatch, t)}
                                                           </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>

                                                            <div className="mb-0">
                                                                <label className="fs-7 fw-normal">
                                                                    {/* {t('Expense Type')} */}
                                                                    {getValueFromResource('Expense Type',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mt-2" id='ExpenseType' value={values.ExpenseType} name='ExpenseType'
                                                                    onChange={handleChange('ExpenseType')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('ExpenseType', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.ExpenseType && errors.ExpenseType &&
                                                                    <p className='errorMsg'>{errors.ExpenseType as string}</p>
                                                                }
                                                            </div>
                                                            <div className="mb-3 mt-2">
                                                                <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                                    {/* {t('Tax Code')} */}
                                                                    {getValueFromResource('Tax Code', dispatch, t)}
                                                                    <div
                                                                        style={{ marginBottom: "2px" }}
                                                                        data-tooltip-id="tooltip-expense"
                                                                        data-tooltip-content={getValueFromResource('Tax code linked to expense type. This is for reporting purpose only.', dispatch, t)}
                                                                    >
                                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                                    </div>
                                                                </label>
                                                                <Select
                                                                    value={values.taxcodeList === "" ? taxCodeArray[0] : taxCodeArray.find((option: any) => option.value == values.AccountTaxCodeId)}
                                                                    className="basic-single"
                                                                    classNamePrefix="select"
                                                                    name="taxcodeList"
                                                                    onBlur={() => setFieldTouched('AccountTaxCodeId', true)}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange({
                                                                            target: {
                                                                                id: "AccountTaxCodeId",
                                                                                value: selectedOption?.value
                                                                            },
                                                                        });
                                                                    }}
                                                                    options={taxCodeArray}
                                                                    styles={dropDownSelectionStyles}
                                                                    maxMenuHeight={maxMenuHeight}
                                                                />
                                                            </div>
                                                            <div className="mb-3 mt-2">
                                                                <label className="fs-7 fw-normal">
                                                                    {/* {t('Show Quantity')} */}
                                                                    {getValueFromResource('Show Quantity',dispatch, t)}
                                                                    </label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                    <input className="form-check-input h-20px w-30px mt-2"
                                                                        type="checkbox"
                                                                        checked={values.IsQuantityField}
                                                                        id="IsQuantityField"
                                                                        onChange={handleChange('IsQuantityField')}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="mb-3 mt-2">
                                                                <label className="fs-7 fs-7 fw-normal mb-2">
                                                                    {/* {t('Quantity Caption')} */}
                                                                    {getValueFromResource('Quantity Caption',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='QuantityFieldCaption' value={values.QuantityFieldCaption} name='AccountHolidayType'
                                                                    onChange={handleChange('QuantityFieldCaption')}
                                                                    onBlur={() => setFieldTouched('QuantityFieldCaption')}
                                                                    style={{ color: '#172b4d' }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('QuantityFieldCaption', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>

                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                disabledCount !== 1 ? <div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}
                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div> : expensetypeList.find(x => x.AccountExpenseTypeId === values.AccountExpenseTypeId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}
                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div>)
                                                            ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}

                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                            {/* {t('Save')} */}
                                                            {getValueFromResource('Save',dispatch, t)}

                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
            <ReactTooltip
                id="tooltip-expense"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default ExpenseTypeForm;